import React from "react";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { DraggableDialog } from "../../consts";
import FeatherIcon from "feather-icons-react";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message, loading, okText = "Confirm", cancelText = "Cancel" }) => {
    const handleClose = (event, reason) => {
        // Prevent closing the dialog on backdrop click or escape key press
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
        }
        event.stopPropagation();
        onClose(null);
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="confirm-dialog-description"
            scroll="paper"
            disableEscapeKeyDown={true}
            fullWidth={true}
            maxWidth="xs"
            PaperComponent={DraggableDialog}
            onClick={(e) => e.stopPropagation()}
        >
            <DialogTitle
                id="draggable-dialog-title"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                gap={1}
            >
                {title}
                <IconButton
                    className="draggable-cancel"
                    size="small"
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        color: theme.palette.grey[400],
                        marginRight: "-.5rem",
                    })}
                >
                    <FeatherIcon icon="x" />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <DialogContentText id="confirm-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    type="button"
                    variant="outlined"
                    onClick={handleClose}
                >
                    {cancelText}
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    onClick={(e) => {
                        e.stopPropagation();
                        onConfirm(e)
                    }}
                >
                    {loading ? <CircularProgress color="inherit" size={24} /> : okText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
